import React, { useEffect } from 'react';
import "swiper/css/bundle";
import "./SwiperSection.css";
import { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';

// import required modules
import { EffectCoverflow, Pagination ,Navigation,Autoplay} from "swiper";
import { client, urlFor } from '../../Client';
// import Loading from '../Shared/Loading';
import { motion } from 'framer-motion';
import {MdTrendingFlat} from 'react-icons/md';
import Button from '@mui/material/Button';
import pinky from '../../assets/img/sparkling-glitters-cover.png';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Card from './Card';

const SwiperSection = () => {
  const tags = 
  ['HTML',
  'CSS',
  'Bootstrap',
  'Tailwind Css',
  'Material UI',
  'Chakra UI',
  'Vanila Js',
  'TypeScript',
  'React JS',
  'Next Js',
  'MongoDB',
  'Node Js',
  'Express Js',
  'Stripe',
  'Sanity',
  'git',
  'All']

    const[activeFilter,setActiveFilter] = useState('All');
    const[animateCard,setAnimateCard] = useState({y:0,opacity:1});
    const [works,setWorks]= useState([]);
    const [filterWork,setFilterWork] = useState([]);
    console.log(filterWork);

    const navigate= useNavigate();

    useEffect(()=>{
        const query = '*[_type=="works"]';

        client.fetch(query)
        .then((data)=>{
            setWorks(data);
            setFilterWork(data);
            console.log(data);
        })
    },[]);

    const handleWorkFilter=(item)=>{
        setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === 'All') {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
    }

    return (
          <div className='overflow-x-hidden '>
             

        <div className="app__work-filter flex justify-center items-center">
          {tags.map((item, index) => (
            <div
              key={index}
              onClick={() => handleWorkFilter(item)}
              className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : ''}`}
            >
              {item}
            </div>
          ))}
        </div>
        {/* <motion.div
  animate={animateCard}
  transition={{ duration: 0.5, delayChildren: 0.5 }}
  className="app__work-portfolio   overflow-x-hidden"
>
        <Swiper
        // loop={true}
        autoplay={{
          "delay": 2500,
          // "disableOnInteraction": false
        }}
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={1}
        spaceBetween={10}
        // navigation={true} 
        breakpoints={{
          640: {
            width: 640,
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          768: {
            width: 768,
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1080: {
            width: 1080,
            slidesPerView: 3,
            spaceBetween: 40,
          },
        }}
        coverflowEffect={{
           "rotate":25,
            "stretch": 0, 
            "depth": 100, 
            "modifier": 1, 
            "slideShadows": false }} 
        pagination={true}
        modules={[EffectCoverflow, Pagination]}
        className=""
      >
        <div className='box-border max-w-screen-lg overflow-hidden'>
          {
            filterWork.map((element=>{
              return(
                <SwiperSlide key={element._id}>
                  <FilteredWork work={element}/>
                </SwiperSlide>
              )
            }
              ))
          }
          

        </div>
        
      
      

      </Swiper>
      </motion.div> */}
      <div>
      <Swiper
        // loop={true}
        autoplay={{
          "delay": 2500,
          // "disableOnInteraction": false
        }}
        loop={true}
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={1}
        spaceBetween={10}
        // navigation={true} 
        breakpoints={{
          640: {
            width: 640,
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            width: 768,
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1080: {
            width: 1080,
            slidesPerView: 3,
            spaceBetween: 40,
          },
        }}
        coverflowEffect={{
           "rotate":25,
            "stretch": 0, 
            "depth": 100, 
            "modifier": 1, 
            "slideShadows": false }} 
        pagination={true}
        modules={[EffectCoverflow, Pagination]}
        className="mx-auto relative"
      >
        
            
            {
            filterWork.map((element=>{
              return(
                
                <SwiperSlide className='absolute z-50' key={element._id}>
                    <Card element={element}/>
                </SwiperSlide>
                
              )
            }
              ))
           }
            

            </Swiper>
      </div>
        </div>
    );
};

export default SwiperSection;